module.exports = __webpack_public_path__ + "img/mdi_person-multiple.167a1f31.svg";